export default "__VITE_ASSET__DSaQehf6__"